import React, { memo } from 'react'

import { TURN_STATUS } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import Composer from 'Pods/ThreeDStudio/Shared/Composer/Composer'

import Conversation from './Components/Conversation/Conversation'
import NewImageNote from './Components/NewImageNote/NewImageNote'
import useCreateTab from './useCreateTab'

function CreateTab() {
  const t = useTranslation()
  const {
    prompt,
    attachments,
    messages,
    tags,
    isGenerating,
    isUploadDisabled,
    fileInputRef,
    handlePromptChange,
    handleTagClick,
    handleUploadClick,
    handleRemoveAttachment,
    handleFilesChange,
    handleSend,
    handleRegenerate,
    handleGenerateAgain,
    handleApply,
    handleEdit,
  } = useCreateTab()

  const isSendDisabled = isGenerating || !prompt.trim()
  const hasGeneratedImage = messages.some(message => message.status === TURN_STATUS.DONE && message.result)

  return (
    <div className="image-assistant-create-tab__create">
      <Conversation
        messages={messages}
        isGenerating={isGenerating}
        onApply={handleApply}
        onRegenerate={handleRegenerate}
        onGenerateAgain={handleGenerateAgain}
        onEdit={handleEdit}
      />
      <Composer
        prompt={prompt}
        attachments={attachments}
        tags={tags}
        fileInputRef={fileInputRef}
        sendLabel={t('imageAssistantPanel.createTab.composer.send')}
        notice={hasGeneratedImage ? <NewImageNote /> : null}
        isSendDisabled={isSendDisabled}
        isUploadDisabled={isUploadDisabled}
        onPromptChange={handlePromptChange}
        onTagClick={handleTagClick}
        onUploadClick={handleUploadClick}
        onRemoveAttachment={handleRemoveAttachment}
        onFilesChange={handleFilesChange}
        onSend={handleSend}
      />
    </div>
  )
}

export default memo(CreateTab)
